import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
import MoneyFormat from './MoneyFormat'
import { useFormat } from 'Services/localize/format'
import { useTranslation } from 'react-i18next'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { FilledTextField } from 'components/OWForm/FilledTextField/FilledTextField'
import { forwardRef } from 'react'

interface MoneyInputProps {
    name?: string
    error?: boolean
    helperText?: any
    label?: string
    readOnly?: boolean
    autocomplete?: string
    disabled?: boolean
    currencySymbol?: string
}

/**
 * Money Input with has Currency sign
 * $12.23, $20.22, $200
 */
function MoneyInputComponent(
    {
        onChange,
        value,
        name,
        error,
        helperText,
        fullWidth = false,
        label = '',
        onBlur,
        readOnly = false,
        autocomplete = 'off',
        disabled = false,
        currencySymbol,
        onClick,
        ...textFiledProps
    }: MoneyInputProps & TextFieldProps,
    ref?: any,
) {
    const { currencySymbol: defaultCurrencySymbol, currencyCode } = useFormat()
    const { t } = useTranslation()
    const { isMobile } = useScreenSize()

    const Component = isMobile ? FilledTextField : TextField

    return (
        <Component
            {...textFiledProps}
            autoComplete={autocomplete}
            label={t(label)}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            error={Boolean(error)}
            helperText={helperText}
            disabled={disabled}
            InputProps={{
                inputComponent: MoneyFormat,
                startAdornment:
                    currencyCode !== 'THB' ? (
                        <InputAdornment position="start">
                            {currencySymbol || defaultCurrencySymbol}
                        </InputAdornment>
                    ) : undefined,
                endAdornment:
                    currencyCode === 'THB' ? (
                        <InputAdornment position="start">
                            {currencySymbol || defaultCurrencySymbol}
                        </InputAdornment>
                    ) : undefined,
                readOnly,
            }}
            fullWidth={fullWidth}
            placeholder={'0.00'}
            onFocus={(e) => {
                const value = parseFloat(e.target.value)
                value === 0 && e.target.select()
            }}
            onClick={onClick}
            ref={ref}
        />
    )
}

const MoneyInput = forwardRef<any, MoneyInputProps & TextFieldProps>(
    MoneyInputComponent,
)

export default MoneyInput
